import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "https://api.warung.io/",
  headers: {
    "x-tenant-id":
      process.env.REACT_APP_TENANT_ID || "61a83605e4a414a184c3f025",
  },
});
